import React, { useEffect, useState } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";
import Utils, { hasItems } from "../../../helpers/utils";

import moment from "moment";

import Dialog from "../common/dialog";
import ManaButton from "../common/ManaButton";
import AppTheme from "../AppTheme";

import DATE_FORMATS from "./header/formats";

export default function ReportWeekSelectorDialog({
  days,
  timeUnit = "week",
  onDateSelected = () => {},
  close = () => {},
}) {
  const [intervalColumns, setIntervalColumns] = useState([]);

  useEffect(() => {
    if (!hasItems(days)) return;

    const format = DATE_FORMATS[timeUnit].intervalButtonsFormat;
    if (!format) return [];

    const currentQ = moment().format(
      DATE_FORMATS.quarter.intervalButtonsFormat,
    );

    const intervals = days.map((d) => {
      const date = moment(d.day).endOf(
        timeUnit === "week" ? "isoWeek" : timeUnit,
      );

      return {
        day: date.format("YYYY-MM-DD"),
        label: Utils.formatDateByTimeUnit({
          date: d.day,
          timeUnit,
          format,
          currentInterval: timeUnit == "quarter" ? currentQ : null,
        }),
      };
    });

    setIntervalColumns(intervals.reverse());
  }, []);

  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingTop: 0,
        marginTop: 0,
        paddingBottom: 20,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.headerText}>
          Submit report for {timeUnit == "week" ? "week ending" : ""}:
        </Text>
      </View>

      <View style={styles.buttons}>
        {intervalColumns.map((d, index) => (
          <ManaButton
            isMainButton
            key={index}
            style={styles.button}
            text={d.label}
            styleText={styles.cancelButtonText}
            onPress={() => onDateSelected(d.day)}
          />
        ))}
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    paddingVertical: 12,
    paddingRight: 12,
  },
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    textAlign: "center",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 240,
    height: 36,
    marginBottom: 8,
  },
});
